import { IApiError } from '@/infra/exceptions/interfaces/api-error';

export const isApiError = (error: unknown): error is IApiError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'traceId' in error &&
    'title' in error &&
    'status' in error &&
    'errors' in error &&
    Array.isArray((error as IApiError).errors)
  );
};
